/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Action, State } from '../redux';

const initialState: State['entry'] = {
  // TODO: figure out pattern of asserting null values as NonNullable in a post load state
  current: null as any,
  entryTask: null as any,
  isLocked: false,
};

export function journalReducer(state = initialState, action: Action) {
  switch (action.type) {
    case 'SET_JOURNAL_ENTRY':
      return {
        ...state,
        current: action.payload.current,
        entryTask: action.payload.entryTask,
        isLocked: action.payload.isLocked,
      };
    default:
      return state;
  }
}
